
export const DragTypes = {
   EVENT: "event",
   PLANNER_VEHICLE: "planner-vehicle",
   DROP_OFF_LEAD: "drop-off-lead",
   IMAGE_TYPE_ORDER: "image-type-order",
}
